export default {"src":"/_next/static/media/finance.d49b17df.svg","height":36,"width":36};